import {
    dictionaryReviewApi,
    DictionaryReviewQueueParams,
    DictionaryReviewSummaryParams,
} from '../api/dictionaryReviewApi';
import type { DictionaryReviewPage, DictionaryReviewSummary } from '../types/dictionaryReview';
import { useBaseQuery } from './useBaseQuery';

export const dictionaryReviewKeys = {
    all: ['dictionaryReview'] as const,
    queue: (params: DictionaryReviewQueueParams) =>
        [...dictionaryReviewKeys.all, 'queue', params] as const,
    summary: (params: DictionaryReviewSummaryParams) =>
        [...dictionaryReviewKeys.all, 'summary', params] as const,
};

export const useDictionaryReviewQueue = (params: DictionaryReviewQueueParams) =>
    useBaseQuery<DictionaryReviewPage>(
        dictionaryReviewKeys.queue(params),
        () => dictionaryReviewApi.getQueue(params),
        { staleTime: 30 * 1000 },
    );

export const useDictionaryReviewSummary = (params: DictionaryReviewSummaryParams) =>
    useBaseQuery<DictionaryReviewSummary>(
        dictionaryReviewKeys.summary(params),
        () => dictionaryReviewApi.getSummary(params),
        { staleTime: 30 * 1000 },
    );
